import { cn } from "@/lib/utils";
import { CheckCircledIcon, CrossCircledIcon, InfoCircledIcon } from "@radix-ui/react-icons";
import React from "react";
import { toast } from "sonner";

const Toaster = {
    info: (message: string) => {
        Toaster.toast(message, InfoCircledIcon, "blue");
    },
    success: (message: string) => {
        Toaster.toast(message, CheckCircledIcon, "green");
    },
    error: (message: string) => {
        Toaster.toast(message, CrossCircledIcon, "red");
    },
    toast: (message: string, icon: React.ElementType, color: string) => {
        toast(
            <>
                {React.createElement(icon, { className: cn(`text-${color}-500`, "inline-block w-4 h-4 mr-1") })}
                {message}
            </>
        );
    }
};

export default Toaster;
